var SaTableController = (function () {
    function SaTableController(topic) {
        this.topic = topic;
        this.visible = false;
        this.tableName = 'Sales Assist';
        this.tableHeaders = [
            'Deal Reg Product Group ID',
            'Sales',
            'Engagement',
            'Engagement ID',
            'Sales Order',
        ];
    }
    SaTableController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    SaTableController.prototype.getValue = function (value) {
        if (value === true) {
            return 'Yes';
        }
        else if (value === false) {
            return 'No';
        }
        else if (value !== undefined && value.trim() === '') {
            return 'Not Applicable';
        }
        return value;
    };
    SaTableController.$inject = ['topic'];
    return SaTableController;
}());
angular
    .module('application')
    .component('salesAssistTable', new SaTableComponent());

//# sourceMappingURL=saTableController.js.map
